import GeolocationPermission from './GeolocationPermission'

export default GeolocationPermission
